import React from 'react';
import CustomHeader from './CustomHeader';
import Footer from './Footer';
import './Layout.css';

function Layout({ children }) {
  return (
    <div className="layout">
      <CustomHeader />
      <main className="main-content">{children}</main>
      <Footer />
    </div>
  );
}

export default Layout; 